/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  return {
    variables: { id: props.id },
    pause: !props.id,
  }
}
